import { useState, useEffect } from 'react';

// Checks if the element is in the viewport
export const useIntersection = (element, rootMargin = '0px') => {
	const [isVisible, setState] = useState(false);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				setState(entry.isIntersecting);
			},
			{ rootMargin }
		);

		const { current } = element;

		if (current) {
			observer.observe(current);
		}

		return () => observer.unobserve(current);
	}, []);

	return isVisible;
};
